import { render, staticRenderFns } from "./CodingWidgetElement.vue?vue&type=template&id=2b4d4e74&scoped=true&"
import script from "./CodingWidgetElement.vue?vue&type=script&lang=js&"
export * from "./CodingWidgetElement.vue?vue&type=script&lang=js&"
import style0 from "./CodingWidgetElement.vue?vue&type=style&index=0&id=2b4d4e74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d4e74",
  null
  
)

export default component.exports